import type { Setting, Texts, PackageItem } from "@/type";

interface PackageItemsCardProps {
  settings: Setting;
  texts: Texts;
  items: PackageItem[];
}

export default function PackageItemsCard({ settings, texts, items }: PackageItemsCardProps) {
  const { style, font_family } = settings;
  const { colors, general_content_text_size, borders } = style;

  const titleStyle = {
    color: colors.text_color.information_title_text,
    fontSize: general_content_text_size.information_title_text,
    fontWeight: 650,
    lineHeight: "20px",
    marginBottom: 16,
  };

  const infoStyle = {
    color: colors.text_color.information_text,
    fontSize: general_content_text_size.information_text,
    fontWeight: 450,
    lineHeight: "20px",
  };

  return (
    <div
      className="overflow-clip"
      style={{
        backgroundColor: colors.general_color.information_card_background,
        borderRadius: borders.information_card_corner_radius,
        fontFamily: font_family.font,
        border: "1px solid #e3e3e3",
        padding: 16,
      }}
    >
      <p style={titleStyle}>{texts.package_items}</p>
      <div className="flex flex-col" style={{ gap: 16 }}>
        {items.map((item, idx) => (
          <div key={idx} className="flex items-start" style={{ gap: 12 }}>
            {item.image_url ? (
              <img
                src={item.image_url}
                alt={item.product_name || ""}
                className="object-cover flex-shrink-0"
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: borders.product_image_corner_radius,
                  border: "1px solid #e3e3e3",
                }}
              />
            ) : (
              <div
                className="flex-shrink-0"
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: borders.product_image_corner_radius,
                  border: "1px solid #e3e3e3",
                }}
              />
            )}
            <div className="flex-1 min-w-0 flex flex-col" style={{ gap: 4 }}>
              <div className="flex items-center justify-between">
                <p className="truncate" style={infoStyle}>
                  {item.product_name}
                </p>
                <div className="flex items-center flex-shrink-0" style={{ gap: 4 }}>
                  <span className="whitespace-nowrap" style={infoStyle}>
                    ${(item.price ?? 0).toFixed(2)} ×
                  </span>
                  <span
                    className="flex items-center justify-center"
                    style={{
                      backgroundColor: "rgba(0,0,0,0.06)",
                      borderRadius: 8,
                      height: 20,
                      paddingLeft: 8,
                      paddingRight: 8,
                      fontSize: 12,
                      fontWeight: 450,
                      lineHeight: "16px",
                      color: colors.text_color.information_text,
                    }}
                  >
                    {item.quantity ?? 1}
                  </span>
                </div>
              </div>
              {item.variant_name && (
                <span
                  className="inline-flex items-center justify-center self-start"
                  style={{
                    backgroundColor: "rgba(0,0,0,0.06)",
                    borderRadius: 8,
                    height: 20,
                    paddingLeft: 8,
                    paddingRight: 8,
                    fontSize: 12,
                    fontWeight: 450,
                    lineHeight: "16px",
                    color: colors.text_color.information_text,
                  }}
                >
                  {item.variant_name}
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
